import { EMPTY_OBJECT } from './empties';
export default function determineTheme(props, providedTheme, defaultProps) {
    if (defaultProps === void 0) { defaultProps = EMPTY_OBJECT; }
    return (props.theme !== defaultProps.theme && props.theme) || providedTheme || defaultProps.theme;
}
//# sourceMappingURL=determineTheme.js.map